import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Link, Stack } from "@mui/material";
import { Grid } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Table as TableType,
  FibreList,
  CatalogueTable,
} from "../../Constants/GlobalConstant";
import {
  getDataType,
  atLeastOneNull,
} from "../../CommonFuntion/SchemaValidation";
import { getLabelTypeForSession } from "../../CommonFuntion/CheckSession";
import { useLocation, createSearchParams } from "react-router-dom";
import HeaderCardComponent from "./DialogHeaderCardComponent";
import FibreCardComponent from "./DialogFibreCardComponent";
import TableCardComponent from "./DialogTableCardComponent";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function CustomizedDialogs(props) {
  const { diaglogTitle, formData, key2, post, PO, ProductDesc, TableName } = props;
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const searchParams = createSearchParams(location.search);
  const schemaObject2 = useSelector((state) => state.SchemaObject);
  const LabelSession2 = useSelector((state) => state.LabelSession);
  var SessionArray = useSelector((state) => state.SessionArray);
  let user_id = "";
  let schema_name = "";
  let labelSessionArray = [];

  if (typeof post.post !== "undefined") {
    SessionArray = post.post.paxWebSessionStrings;
  }
  SessionArray?.forEach(function (item) {
    if (item.Key == "user_id") {
      user_id = item.Value;
    }
    if (item.Key == "LabelList") {
      const jsonData = JSON.parse(item.Value);

      const occLabelList = jsonData.OCCLabelList;
      schema_name = jsonData.SchemaName;
      const distinctValues = [
        ...new Set(occLabelList.map((item) => item.LabelReference)),
      ];
      labelSessionArray = distinctValues;
    }
  });
  let newArray = labelSessionArray.map((element) => {
    let parts = element.split("[");
    return parts[0]; // Removes the trailing ']'
  });

  var saveLabelSessionValue = JSON.parse(
    JSON.stringify({ LabelSession: newArray })
  );

  if (!searchParams.get("OCC")) {
    let firstPageIdRaw = JSON.parse(localStorage.getItem("firstPageID"));
    let LabelsFromLabelSelectionPage = JSON.parse(
      localStorage.getItem("SU" + firstPageIdRaw + user_id + "saveUser")
    );
    let labelEntriesForDialog = [];
    if (LabelsFromLabelSelectionPage) {
      const arr = Object.values(LabelsFromLabelSelectionPage);
      labelEntriesForDialog = arr.filter(
        (e) => typeof e === "string" && e.includes("[")
      );
    }
    // If firstPageID SU didn't contain label entries (it may be a data page, not
    // the label-selection page), scan other SU keys to find the real label list.
    // Pick the SU with the MOST label entries to avoid stale/unrelated SU data.
    if (labelEntriesForDialog.length === 0) {
      var bestSuLabels = [];
      for (var si = 0; si < window.localStorage.length; si++) {
        var suScanKey = window.localStorage.key(si);
        if (
          suScanKey.slice(0, 2) === "SU" &&
          suScanKey.includes(user_id) &&
          suScanKey !== "SU" + firstPageIdRaw + user_id + "saveUser"
        ) {
          try {
            var suData = JSON.parse(window.localStorage.getItem(suScanKey));
            if (suData) {
              var suValues = Object.values(suData);
              var suLabels = suValues.filter(
                (e) => typeof e === "string" && e.includes("[")
              );
              if (suLabels.length > bestSuLabels.length) {
                bestSuLabels = suLabels;
              }
            }
          } catch (_) { /* skip malformed entries */ }
        }
      }
      labelEntriesForDialog = bestSuLabels;
    }
    if (labelEntriesForDialog.length > 0) {
      let newArray2 = labelEntriesForDialog.map((element) => {
        let parts = element.split("[");
        return parts[0];
      });
      saveLabelSessionValue = JSON.parse(
        JSON.stringify({ LabelSession: newArray2 })
      );
      labelSessionArray = labelEntriesForDialog;
    }
  }
  const LabelSession =
    saveLabelSessionValue !== null ? saveLabelSessionValue : LabelSession2;
  var allPageObjectData = [];
  var labelToSchemaIndex = {};
  var keyArray = [];
  var SOKeys = [];
  var SUKeys = [];
  for (var i = 0; i < window.localStorage.length; i++) {
    var key = window.localStorage.key(i);
    let isCurrentSession = key.includes(user_id);
    if (isCurrentSession) {
      if (key.slice(0, 2) === "SO") {
        SOKeys.push(key);
      }
      if (key.slice(0, 2) === "SU") {
        SUKeys.push(key);
      }
    }
    keyArray.push(key);
  }

  // Read label→PageID mapping for SO key fallback
  var labelPageIdMap = {};
  try { labelPageIdMap = JSON.parse(window.localStorage.getItem("labelPageIdMap")) || {}; } catch (_e) { /* ignore */ }

  if (atLeastOneNull(LabelSession.LabelSession)) {
    for (var i = 0; i < LabelSession.LabelSession.length; i++) {
      var SOkey = SOKeys.find((element) =>
        element.includes(JSON.parse(localStorage.getItem("firstPageID")))
      );

      if (true) {
        var t = JSON.parse(window.localStorage.getItem(SOkey));
        if (t !== null) {
          allPageObjectData.push(t[t.length - 1]);
        }
      }
    }
  } else {
    for (var i = 0; i < LabelSession.LabelSession.length; i++) {
      const labelName = LabelSession.LabelSession[i];
      if (!labelName) continue; // skip undefined/null entries
      // Try label type first (SO keys use label type, not label name)
      const labelType = getLabelTypeForSession(labelName, labelSessionArray);
      var SOkey = SOKeys.find((element) =>
        element.includes("SO" + (labelType || labelName) + user_id + "saveSchemaObject")
      );
      // Fallback: try label name if type didn't match
      if (!SOkey && labelType) {
        SOkey = SOKeys.find((element) =>
          element.includes("SO" + labelName + user_id + "saveSchemaObject")
        );
      }
      // Fallback: try labelPageIdMap
      const labelPageId = labelPageIdMap[labelName];
      if (!SOkey && labelPageId) {
        SOkey = SOKeys.find((element) =>
          element.includes("SO" + labelPageId + user_id + "saveSchemaObject")
        );
      }
      // Fallback: try firstPageID
      if (!SOkey) {
        SOkey = SOKeys.find((element) =>
          element.includes(JSON.parse(localStorage.getItem("firstPageID")))
        );
      }

      if (SOkey) {
        var t = JSON.parse(window.localStorage.getItem(SOkey));
        if (t !== null) {
          allPageObjectData.push(t[t.length - 1]);
          labelToSchemaIndex[labelName] = allPageObjectData.length - 1;
        }
      }
    }
  }
  const schemaObject =
    allPageObjectData.length > 0 ? allPageObjectData : schemaObject2;
  // Use ProductDesc to find the correct schema page for this label,
  // falling back to key2 index, then progressive fallbacks.
  const schemaIndex = (ProductDesc && labelToSchemaIndex[ProductDesc] !== undefined)
    ? labelToSchemaIndex[ProductDesc]
    : key2;
  var pageFields = Array.isArray(schemaObject?.[schemaIndex]) ? schemaObject[schemaIndex]
    : (Array.isArray(schemaObject) && schemaObject.length > 0 && Array.isArray(schemaObject[0]) ? schemaObject[schemaObject.length - 1]
    : (Array.isArray(schemaObject) && schemaObject.length > 0 && !Array.isArray(schemaObject[0]) ? schemaObject
    : []));

  // Robust fallback: if pageFields doesn't contain field definitions matching
  // the formData's table keys, scan ALL SO schemas to find the correct one.
  var formDataTableKeys = Object.keys(formData).filter(
    (k) => Array.isArray(formData[k]) && formData[k].length > 0 && typeof formData[k][0] === "object"
  );
  if (formDataTableKeys.length > 0 && Array.isArray(pageFields)) {
    var hasMatchingField = formDataTableKeys.some(
      (tk) => pageFields.some((f) => f && f.fieldName === tk)
    );
    if (!hasMatchingField) {
      // Current schema doesn't define any of the formData's table keys — search all SO schemas
      for (var si2 = 0; si2 < SOKeys.length; si2++) {
        try {
          var soData = JSON.parse(window.localStorage.getItem(SOKeys[si2]));
          if (soData && Array.isArray(soData)) {
            var lastPage = soData[soData.length - 1];
            if (Array.isArray(lastPage)) {
              var soMatch = formDataTableKeys.some(
                (tk) => lastPage.some((f) => f && f.fieldName === tk)
              );
              if (soMatch) {
                pageFields = lastPage;
                break;
              }
            }
          }
        } catch (_) { /* skip */ }
      }
    }
  }

  // If pageFields is still empty but schemaObject2 from Redux has data, use it directly
  if ((!pageFields || pageFields.length === 0) && Array.isArray(schemaObject2) && schemaObject2.length > 0) {
    if (Array.isArray(schemaObject2[0])) {
      // array-of-arrays: pick first available page
      pageFields = schemaObject2[schemaIndex] || schemaObject2[0];
    } else {
      // flat array of field objects
      pageFields = schemaObject2;
    }
  }
  const libData = pageFields?.filter((x) => x.prefix === "LIB");
  libData?.forEach((x) => {
    let formResult = formData[x.fieldName];
    if (formResult && Array.isArray(formResult)) {
      let newFormResult = {};
      formResult?.forEach((data, index) => {
        const pos = index + 1;
        newFormResult[x.fieldName + "_" + pos] = data[x.fieldName];
      });
      formData[x.fieldName] = [newFormResult];
    }
  });

  // Inject STC (Static) field values from schema into formData so they render in the dialog.
  if (Array.isArray(pageFields)) {
    for (const field of pageFields) {
      if (field.prefix === "STC" && field.value !== undefined && field.value !== "" && !(field.fieldName in formData)) {
        formData[field.fieldName] = field.value;
      }
    }
  }

  // Collect hidden STC field names (display === false) to exclude from rendering
  const hiddenStcFields = new Set(
    (Array.isArray(pageFields) ? pageFields : [])
      .filter((f) => f.prefix === "STC" && f.display === false)
      .map((f) => f.fieldName)
  );

  // When TableName is provided, build a filtered copy of formData that strips
  // only competing MAPPED Table/CatalogueTable arrays (those in LableTableMapPart)
  // while keeping unmapped tables, Care Code List, FibreList, List Builder.
  // Also filter by tabValue so only fields belonging to the same tab are shown.
  let effectiveFormData = formData;

  // Collect all mapped table itemIds from LableTableMapPart in the LAB field
  let mappedTableItemIds = [];
  if (TableName && Array.isArray(pageFields)) {
    const labField = pageFields.find((f) => f.prefix === "LAB");
    const lableTableMapPart = labField?.validation?.LableTableMapPart;
    if (lableTableMapPart) {
      mappedTableItemIds = lableTableMapPart
        .split("|")
        .map((part) => part.split("#")[1])
        .filter(Boolean);
    }
  }

  // Build a set of fieldNames for tables that are mapped (their itemId is in LableTableMapPart)
  const mappedTableFieldNames = new Set();
  if (mappedTableItemIds.length > 0 && Array.isArray(pageFields)) {
    for (const field of pageFields) {
      if (
        (field.dataType === TableType || field.dataType === CatalogueTable) &&
        field.itemId &&
        mappedTableItemIds.includes(field.itemId.toString())
      ) {
        mappedTableFieldNames.add(field.fieldName);
      }
    }
  }

  if (TableName) {
    const tableSchema = Array.isArray(pageFields)
      ? pageFields.find((f) => f.fieldName === TableName)
      : null;
    const tableTabValue = tableSchema?.tabValue;

    effectiveFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, val]) => {
        // For arrays, only strip MAPPED Table/CatalogueTable types that aren't the current TableName.
        // Unmapped tables (not in LableTableMapPart) are kept — they belong to all labels.
        if (Array.isArray(val) && key !== TableName) {
          const arrDataType = getDataType(pageFields, key);
          if (arrDataType === TableType || arrDataType === CatalogueTable) {
            // Only hide if this table is in the mapped set
            if (mappedTableFieldNames.has(key)) {
              return false;
            }
          }
        }
        // When tabValue is available, only keep fields from the same tab
        if (tableTabValue !== undefined && tableTabValue !== null && Array.isArray(pageFields)) {
          const fieldSchema = pageFields.find((f) => f.fieldName === key);
          if (fieldSchema && fieldSchema.tabValue !== undefined && fieldSchema.tabValue !== tableTabValue) {
            return false;
          }
        }
        return true;
      })
    );
  }

  const headerComponents = Object?.entries(effectiveFormData)?.filter(([key, val]) => {
    if (hiddenStcFields.has(key)) return false;
    const dataType = getDataType(pageFields, key);
    // Arrays with no recognized dataType are table data — never render as header fields
    if (Array.isArray(val) && !dataType) return false;
    return (
      dataType !== TableType &&
      dataType !== FibreList &&
      dataType !== "Care Code List" &&
      dataType !== "List Builder" &&
      dataType !== CatalogueTable
    );
  });

  const tableComponents = Object.entries(effectiveFormData).filter(([key]) => {
    const dataType = getDataType(pageFields, key);
    const isTable =
      dataType === TableType ||
      dataType === "Care Code List" ||
      dataType === "List Builder" ||
      dataType === CatalogueTable;
    if (!isTable) return false;
    // When TableName is provided, only restrict MAPPED Table/CatalogueTable types.
    // Unmapped tables, Care Code List and List Builder should still be shown.
    if (TableName && (dataType === TableType || dataType === CatalogueTable)) {
      if (mappedTableFieldNames.has(key)) {
        return key === TableName;
      }
    }
    return true;
  });

  const fiberComponents = Object.entries(effectiveFormData).filter(
    ([key]) => getDataType(pageFields, key) === FibreList
  );
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // Helper: derive QTY field names from schemaObject based on dataType
  const getQtyFieldNames = (dataType) => {
    const items = Array.isArray(pageFields) ? pageFields : [];
    const filtered = items.filter(
      (item) =>
        (dataType === TableType && item?.prefix === "QTY") ||
        (dataType === CatalogueTable && item?.catalogueSchemaType === 16)
    );
    // Return uppercase names for case-insensitive matching
    return filtered
      .map((item) => item?.fieldName)
      .filter(Boolean)
      .map((name) => String(name).toUpperCase());
  };

  // Helper: determine if a row has only zero quantities (or no qty values present)
  const isZeroQuantityRow = (row, dataType) => {
    if (!row || typeof row !== "object") return false;
    const qtyFieldNames = getQtyFieldNames(dataType);
    const qtyKeys = Object.keys(row).filter((k) => {
      const ku = k.toUpperCase();
      // Match exact schema-derived field names, accounting for possible suffixes (e.g., _1)
      const base = ku.split("_")[0];
      return (
        qtyFieldNames.includes(ku) ||
        qtyFieldNames.includes(base) ||
        // Fallback to legacy check if schema didn't provide names
        (qtyFieldNames.length === 0 && ku.includes("QTY"))
      );
    });
    if (qtyKeys.length === 0) return false; // if no qty keys, don't hide
    const toNumber = (v) => {
      if (v === null || v === undefined || v === "") return 0;
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    };
    return qtyKeys.every((k) => toNumber(row[k]) === 0);
  };

  // Helper: filter out rows with zero quantity for each table's array value
  const filterTableRows = (value, dataType) => {
    if (Array.isArray(value)) {
      return value.filter((row) => !isZeroQuantityRow(row, dataType));
    }
    return value;
  };

  return (
    <div>
      <Link color="inherit" onClick={handleClickOpen} href="#">
        {diaglogTitle}
      </Link>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Line Details
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Stack>
            <Grid
              container
              spacing={{ xs: 1, md: 0.5 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              {Array.from(headerComponents).map(
                ([fieldName, value], index) =>
                  value && (
                    <Grid item xs={2} sm={4} md={12} key={index}>
                      <HeaderCardComponent
                        key={index}
                        fieldName={fieldName}
                        value={value}
                      />
                    </Grid>
                  )
              )}
            </Grid>

            {tableComponents.map(([fieldName, value], index) => {
              const dataType = getDataType(pageFields, fieldName);
              const filteredValue = filterTableRows(value, dataType);
              if (Array.isArray(filteredValue) && filteredValue.length === 0) {
                return null; // hide entire table card if all rows are zero-qty
              }
              return (
                <TableCardComponent
                  key={index}
                  fieldName={fieldName}
                  value={filteredValue}
                />
              );
            })}
            {fiberComponents.map(([fieldName, value], index) => (
              <FibreCardComponent
                key={index}
                fieldName={fieldName}
                value={value}
              />
            ))}
          </Stack>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}
